module.exports = __webpack_public_path__ + "static/img/bigNotes.8131538c.jpg";